namespace TabAurous.Inventory {
    export interface CertificationReturnBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.LookupEditor;
        BOMProductId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BOMAttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemType: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        BomRate: AmountEditor;
        BomAmount: AmountEditor;
        Remarks: Serenity.StringEditor;
    }

    export class CertificationReturnBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.CertificationReturnBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CertificationReturnBOMForm.init)  {
                CertificationReturnBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = CommonSubCategoryLookup;
                var w4 = s.StringEditor;
                var w5 = StoneSieveLookup;
                var w6 = s.DecimalEditor;
                var w7 = WeightEditor;
                var w8 = AmountEditor;

                Q.initFormType(CertificationReturnBOMForm, [
                    'ItemTypeId', w0,
                    'ProductTypeId', w1,
                    'BOMProductId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w3,
                    'BOMAttributeId', w4,
                    'ProductCode', w4,
                    'ItemType', w4,
                    'Attribute', w4,
                    'CertificateNo', w4,
                    'KaratId', w1,
                    'ShapeId', w1,
                    'StoneSizeId', w1,
                    'SieveId', w5,
                    'MetalColorId', w1,
                    'StoneColorId', w1,
                    'QualityId', w1,
                    'SettingId', w1,
                    'StoneCutId', w1,
                    'StonePolishId', w1,
                    'StoneSymmetryId', w1,
                    'StoneFluorescenceId', w1,
                    'StoneCuletId', w1,
                    'StoneGirdleId', w1,
                    'StoneTable', w4,
                    'StoneDepth', w4,
                    'Purity', w6,
                    'Pieces', w0,
                    'Weight', w7,
                    'PureWeight', w6,
                    'CalcOnId', w1,
                    'BomRate', w8,
                    'BomAmount', w8,
                    'Remarks', w4
                ]);
            }
        }
    }
}
